import { del, get, post, put } from '@api/request';

export async function fetchBuildingPermitSearchParams(
  { appraisalService },
  authenticationToken,
  { userName },
) {
  const queryParam = userName ? `?userName=${userName}` : '';
  const url = `${appraisalService}/appraisal/buildingpermit/searchparameters${queryParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSearchConfigResults(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/buildingpermitsearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBuildingPermitSearchConfig(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/buildingpermitsearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBuildingPermitCodes(
  { assessmentService, appraisalService },
  authenticationToken,
  { codeType, name, year },
) {
  if (name === 'School Code') {
    const url = `${assessmentService}/assessment/taxingunitssummary`;
    let { body } = await get(authenticationToken, url);
    if (body && body.results && body.results.length > 0) {
      body.results = body.results
        .filter((d) => d.taxingUnitType === 'School')
        .map((item) => ({
          codeName: item.taxingUnitCode,
          codeDescription: item.taxingUnitName,
        }));
    }
    return body;
  } else {
    let url = `${appraisalService}/appraisal/codes?type=${codeType}&name=${name}`;
    if (year) {
      url += `&year=${year}`;
    }
    const { body } = await get(authenticationToken, url);
    return body;
  }
}

export async function insertBuildingPermitSearchParam(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermit/searchparameters`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateBuildingPermitSearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID, payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermit/searchparameter/${searchParamID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteBuildingPermitSearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appraisalService}/appraisal/buildingpermit/searchparameter/${searchParamID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function duplicateBuildingPermitSearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appraisalService}/appraisal/buildingpermit/searchparameter/${searchParamID}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function searchBuildingPermit(
  { appraisalService },
  authenticationToken,
  { options, page, pageSize },
) {
  // if (options.tags) {
  //   let tempOptions = JSON.parse(JSON.stringify(options));
  //   tempOptions.tags = {
  //     operator: '=',
  //     value: options.tags,
  //   };
  //   options = tempOptions;
  // }
  if (options.active && !options.active.value) {
    delete options.active;
  }

  const url = `${appraisalService}/appraisal/buildingpermit/search?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, options);
  return body;
}

export async function massUpdateStatusBuildingPermit(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermits/statusmassupdate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massRematchBuildingPermit(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermits/rematch`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMassRematchLogs(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/buildingpermits/rematch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function massInactiveBuildingPermit(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermits/inactivatemass`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
